import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, message, Modal, Select } from 'antd';
import { authorizeTenant, modifyAuth, AgentTenantAuthVo } from '@/api/tenantAuth';
import { getTenantList, TenantListVo } from '@/api/auth';

export interface EditAuthProp {
  agentId: number;
  data?: AgentTenantAuthVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditAuthModal = ({ agentId, data, isEdit, updateFn, onCancel }: EditAuthProp) => {
  const [form] = Form.useForm();
  const [tenantList, setTenantList] = useState<TenantListVo[]>([]);
  const [loading, setLoading] = useState(false);

  // 加载租户列表
  useEffect(() => {
    setLoading(true);
    getTenantList()
      .then(list => setTenantList(list || []))
      .catch(err => {
        console.error('获取租户列表失败:', err);
        message.error('获取租户列表失败');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue(data);
    }
  }, [data, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, agentId };
      const api = isEdit ? modifyAuth : authorizeTenant;
      api(params as any).then(() => {
        message.success(isEdit ? '修改成功' : '授权成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '修改授权配置' : '授权租户'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="tenantMcid" label="租户" rules={[{ required: true, message: '请选择租户' }]}>
          <Select
            placeholder="请选择租户"
            disabled={isEdit}
            loading={loading}
            showSearch
            optionFilterProp="label"
            options={tenantList.map(t => ({
              value: t.tenantMcid,
              label: t.name,
            }))}
          />
        </Form.Item>
        <Form.Item name="dailyLimit" label="每日调用限制" extra="不填则无限制">
          <InputNumber min={1} style={{ width: '100%' }} placeholder="每日最大调用次数" />
        </Form.Item>
        <Form.Item name="monthlyLimit" label="每月调用限制" extra="不填则无限制">
          <InputNumber min={1} style={{ width: '100%' }} placeholder="每月最大调用次数" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAuthModal;